import Repository from "@/repository";

const flattenTireGroups = (groups) => {
  if (!Array.isArray(groups)) {
    return [];
  }
  return groups.flatMap((group) => group.tires || []);
};

const mergeGroupsByDiameter = (collections) => {
  const groupsMap = new Map();

  collections.forEach((groups) => {
    (groups || []).forEach((group) => {
      const diameter = String(group.diameter);
      const current = groupsMap.get(diameter) || {
        ...group,
        tires: [],
      };
      const tireIds = new Set(current.tires.map((item) => item.id));

      (group.tires || []).forEach((tire) => {
        if (!tireIds.has(tire.id)) {
          current.tires.push(tire);
          tireIds.add(tire.id);
        }
      });

      groupsMap.set(diameter, current);
    });
  });

  return Array.from(groupsMap.values()).sort(
    (first, second) => Number(first.diameter) - Number(second.diameter),
  );
};

const fetchTiresByGroup = async (generationId, group) => {
  if (!generationId) {
    return [];
  }

  const attempts = [
    { size: "mm", is_cargo: false },
    { size: "inch", is_cargo: false },
    { size: "mm", is_cargo: true },
    { size: "inch", is_cargo: true },
  ];

  for (const attempt of attempts) {
    const { value } = await Repository.Tires.getSizes({
      size: attempt.size,
      params: {
        is_cargo: attempt.is_cargo,
        group,
        generation: generationId,
      },
    });

    const tires = flattenTireGroups(value);
    if (tires.length) {
      return tires;
    }
  }

  return [];
};

export const fetchStandardTires = (generationId) =>
  fetchTiresByGroup(generationId, "standard");

export const fetchAdditionalTires = (generationId) =>
  fetchTiresByGroup(generationId, "additional");

export const fetchAllTires = async (generationId) => {
  if (!generationId) {
    return { groups: [], tires: [] };
  }

  const attempts = [
    { size: "mm", is_cargo: false },
    { size: "inch", is_cargo: false },
    { size: "mm", is_cargo: true },
    { size: "inch", is_cargo: true },
  ];

  const responses = await Promise.all(
    attempts.map((attempt) =>
      Repository.Tires.getSizes({
        size: attempt.size,
        params: {
          is_cargo: attempt.is_cargo,
          generation: generationId,
        },
      }),
    ),
  );

  const groups = mergeGroupsByDiameter(
    responses.map((response) => (Array.isArray(response.value) ? response.value : [])),
  );
  return {
    groups,
    tires: flattenTireGroups(groups),
  };
};
